export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const ROLE_OPTIONS = ["admin", "account_manager", "sales", "sales_admin", "risk", "researcher", "operations", "operations_admin", "trader", "trader_admin", "viewer"] as const;
